import { render, staticRenderFns } from "./Paquete.vue?vue&type=template&id=23439718&scoped=true&"
import script from "./Paquete.vue?vue&type=script&lang=js&"
export * from "./Paquete.vue?vue&type=script&lang=js&"
import style0 from "./Paquete.vue?vue&type=style&index=0&id=23439718&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23439718",
  null
  
)

export default component.exports